import { parseLatLong } from './overspeedRouteUtils'

const GREEN_DRIVING_EVENT_NAMES = {
  1: 'Harsh Acceleration',
  2: 'Harsh Braking',
  3: 'Harsh Cornering'
}

const toNumber = (value) => {
  const num = Number(value)
  return Number.isFinite(num) ? num : null
}

export const buildGreenDrivingMapEvents = (greenDrivingSummary) => {
  if (!greenDrivingSummary) return []

  const logs = greenDrivingSummary.logs || {}
  const events = []

  ;[1, 2, 3].forEach((typeKey) => {
    const eventLogs = logs[typeKey] || logs[String(typeKey)] || []
    eventLogs.forEach((event, index) => {
      const position = parseLatLong(event && event.lat_long)
      if (!position) return

      const timestamp = toNumber(event && event.timestamp)
      events.push({
        key: `green-driving-${typeKey}-${timestamp != null ? timestamp : index}`,
        eventTypeKey: typeKey,
        eventName: GREEN_DRIVING_EVENT_NAMES[typeKey],
        timestamp,
        position
      })
    })
  })

  return events.sort((a, b) => {
    const aTs = a.timestamp == null ? Number.MAX_SAFE_INTEGER : a.timestamp
    const bTs = b.timestamp == null ? Number.MAX_SAFE_INTEGER : b.timestamp
    return aTs - bTs
  })
}
